const i18nNamespaces = {
  APP: 'app',
  CREDIT_CARD_PAYMENT: 'credit-card-payment',
  PAYMENT_COMPLETE: 'payment-complete',
} as const;

export default i18nNamespaces;
